export default "__VITE_ASSET__D6lyr8rx__"